import { Link } from "react-router-dom";

const plans = [
  {
    name: "Basic",
    tagline: "尝鲜体验",
    price: "免费",
    period: "",
    featured: false,
    features: ["10 次深度研究", "40 次 PPT 生成", "基础文献检索", "社区支持"],
    cta: "免费开始",
    ctaStyle: "outline",
  },
  {
    name: "Plus",
    tagline: "在读学生",
    price: "¥99",
    priceUnit: "/月",
    period: "按年付 ¥79/月",
    featured: false,
    features: ["1 次综述生成", "65 次深度研究", "250 次 PPT", "个人文献中心", "邮件支持"],
    cta: "立即订阅",
    ctaStyle: "outline",
  },
  {
    name: "Pro",
    tagline: "科研主力",
    price: "¥499",
    priceUnit: "/月",
    period: "按年付 ¥399/月",
    featured: true,
    badge: "最受欢迎",
    features: ["8 次综述生成", "315 次深度研究", "1250 次 PPT", "团队协作批注", "优先客服支持"],
    cta: "立即升级",
    ctaStyle: "primary",
  },
  {
    name: "企业版",
    tagline: "机构团队",
    price: "定制",
    period: "",
    featured: false,
    features: ["专属团队方案", "API 无限调用", "私有化部署", "专属客户成功经理"],
    cta: "联系销售",
    ctaStyle: "outline",
  },
];

export default function PricingSection() {
  return (
    <section id="pricing" className="py-24 bg-[#080808]">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-block text-xs text-[#3d69e8] font-medium tracking-widest uppercase mb-4">定价策略</div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">选择适合你的科研伙伴</h2>
          <div className="w-12 h-0.5 bg-[#3d69e8] mx-auto mb-4"></div>
          <p className="text-sm text-white/40">突出「对你有什么用」而非功能罗列</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {plans.map((plan, i) => (
            <div
              key={i}
              className={`relative rounded-2xl p-6 flex flex-col transition-all ${
                plan.featured
                  ? "bg-[#3d69e8] border border-[#3d69e8]"
                  : "bg-[#111111] border border-white/8 hover:border-white/15"
              }`}
            >
              {plan.badge && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-white text-[#3d69e8] text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                  {plan.badge}
                </div>
              )}
              <div className={`text-sm font-bold mb-1 ${plan.featured ? "text-white" : "text-white"}`}>{plan.name}</div>
              <div className={`text-xs mb-5 ${plan.featured ? "text-white/70" : "text-white/40"}`}>{plan.tagline}</div>
              <div className="mb-1">
                <span className={`text-3xl font-bold ${plan.featured ? "text-white" : "text-white"}`}>{plan.price}</span>
                {plan.priceUnit && <span className={`text-sm ${plan.featured ? "text-white/70" : "text-white/40"}`}>{plan.priceUnit}</span>}
              </div>
              <div className={`text-xs mb-5 h-4 ${plan.featured ? "text-white/60" : "text-white/30"}`}>{plan.period}</div>
              <div className={`w-full h-px mb-5 ${plan.featured ? "bg-white/20" : "bg-white/8"}`}></div>
              <ul className="flex-1 flex flex-col gap-2.5 mb-6">
                {plan.features.map((f, fi) => (
                  <li key={fi} className="flex items-start gap-2">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`ri-check-line text-xs ${plan.featured ? "text-white" : "text-[#3d69e8]"}`}></i>
                    </div>
                    <span className={`text-xs leading-relaxed ${plan.featured ? "text-white/80" : "text-white/50"}`}>{f}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/"
                className={`block text-center text-sm font-medium py-2.5 rounded-xl transition-colors cursor-pointer no-underline whitespace-nowrap ${
                  plan.ctaStyle === "primary"
                    ? "bg-white text-[#3d69e8] hover:bg-white/90"
                    : "bg-white/5 hover:bg-white/10 border border-white/15 text-white"
                }`}
              >
                {plan.cta}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
